import log from 'loglevel';
import * as api from '../apis/api';

/**
 * Check for errors. The result has a status and
 * these are the codes:
 *
 * 200: wait time status: agents available
 *      wait time ( > zero )
 *      wait time ( zero )
 * 204: no agents available
 * 211: no agents available outside biz hours
 * Anything else - is a problem
 *
 * @param { string } status code
 * @param { component } component object
 * @param { boolean } disableButton true/false if button should be disabled
 * @returns { null } nothing
 */
export const checkForErrors = (status, component, disableButton) => {
  log.debug('StatusCode', status);
  if (typeof status !== 'undefined') {
    switch (status) {
      case 200: {
        component.setState({
          inactivePage: false,
          showUnavailable: false,
          showNoAgent: false,
        });
        break;
      }
      case 204:
      case 211: {
        component.setState({
          inactivePage: true,
          showUnavailable: false,
          showNoAgent: true,
          buttonDisabled: disableButton,
        });
        break;
      }
      default: {
        component.setState({
          inactivePage: true,
          showUnavailable: false,
          showNoAgent: true,
          buttonDisabled: disableButton,
        });
        break;
      }
    }
  } else {
    component.setState({
      inactivePage: true,
      showUnavailable: false,
      showNoAgent: true,
      buttonDisabled: disableButton,
    });
  }
};

/**
 * Get Estimated Wait Time
 *
 * @param { data } data of user
 * @param { object} component of caller
 * @param { boolean } disableButton true/false if button should be disabled
 * @returns { null } nothing
 */
export const getEstimatedWaitTime = (data, component, disableButton) => {
  api.getEstimatedWait(data)
    .then((result) => {
      log.debug('api.getEstimatedWait', result);
      checkForErrors(result.data.StatusCode, component, disableButton);
      if (component._isMounted) {
        if (Object.keys(result.data).length) {
          let estWaitTime = result.data.EstimatedWaitTime;
          if (result.data.EstimatedWaitTime < 2) {
            estWaitTime = 2;
          }
          component.setState({
            waitTime: estWaitTime,
            waitTimeNotes: result.data.EstimatedWaitTimeNotes,
          });
        } else {
          log.error('api.getEstimatedWait result.data is empty');
          component.setState({
            inactivePage: true,
            showUnavailable: true,
            buttonDisabled: disableButton,
          });
        }
      }
    })
    .catch((error) => {
      log.error('api.getEstimatedWait', error);
      component.setState({
        inactivePage: true,
        showUnavailable: true,
        buttonDisabled: disableButton,
      });
    });
};
